import { render, staticRenderFns } from "./situation.vue?vue&type=template&id=ed4c2906&scoped=true&"
import script from "./situation.vue?vue&type=script&lang=js&"
export * from "./situation.vue?vue&type=script&lang=js&"
import style0 from "./situation.vue?vue&type=style&index=0&id=ed4c2906&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4c2906",
  null
  
)

export default component.exports